<template>
    <div v-if="message"
            class="message-bar-component"
            :class="variantClass">
        <a v-if="showLink"
            class="anchor"
            :href="href"
            target="_blank"
            rel="noopener noreferrer">
            <span> 
                {{ message }}
            </span>

            <span class="linkText">
                {{ linkText }}
            </span>
        </a>
        <span v-else>
            {{ message }}
        </span>
    </div>
</template>

<script>
    export default {
        name: 'MessageBar',

        props: {
            brand: {
                type: String,
                default: 'giant',
            },
            locale: {
                type: String,
                default: '',
            },
            proxyPath: {
                type: String,
                default: '/ApiProxy/MessageBar',
            },
        },

        data() {

            return {
                message: '',
                link: null,
                linkText: '',
                variant: 'Primary',
                isLoading: true,
                effectiveLocale: '',
                effectiveBrand: 'giant',
            };
        },

        computed: {
            href() {
                return this.link ? String(this.link).trim() : '';
            },

            showLink() {
                return Boolean(this.href && String(this.linkText).trim());
            },

            variantClass() {
                return {
                    isPrimary: this.variant === 'Primary',
                    isSecondary: this.variant === 'Secondary',
                    isTertiary: this.variant === 'Tertiary',
                };
            },
        },

        async mounted() {

            if (!this.effectiveLocale) {
                this.isLoading = false;
                return;
            }
             
            try {
                const params = new URLSearchParams({
                    Brand: this.effectiveBrand,
                    Locale: this.effectiveLocale
                });
                // build api url
                const culture = window.culture || 'global';
                const culturePrefix = culture.startsWith('/') ? culture : `/${culture}`;
                const proxyPath = `${culturePrefix}/apiproxy/messagebar`;
                const url = `${proxyPath}?${params.toString()}`;

                const response = await fetch(url, {
                    method: 'GET',
                    credentials: 'same-origin',
                    headers: { Accept: 'application/json' },
                });

                if (!response.ok) {
                    throw new Error(`Message bar HTTP ${response.status}`);
                }

                const data = await response.json();

                // API: MessageBarResponseModel — zie Next messageBarFromApi
                const apiMessage = (data.message != null ? String(data.message) : '').trim();
                if (!apiMessage) {
                    return;
                }

                const apiLink = data.linkUrl != null ? String(data.linkUrl).trim() : '';
                const hasApiLink = Boolean(apiLink);

                this.message = apiMessage;
                this.link = hasApiLink ? apiLink : null;
                this.linkText = hasApiLink && data.linkLabel != null ? String(data.linkLabel) : '';
                this.variant = data.variant || 'Primary';


            } catch (e) {
                console.error('Failed to load message bar', e);
            } finally {
                this.isLoading = false;
            }
        }, 

        methods: {}, 

        created() {
            const el = document.getElementById('vue-message-bar');
            this.effectiveLocale = el?.dataset.locale || this.locale || '';
            this.effectiveBrand = el?.dataset.brand || this.brand || 'giant';
        }
    };
</script>